/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { toastError } from "../../../utils/sysToast";
import { Calendar } from "primereact/calendar";
import { ExportSheet } from "react-xlsx-sheet";
import XLSX from "xlsx";

class Visits extends Component {
  state = {
    data: {
      Name: "",
      Series: "",
      Price: "",
    },

    dates: "",

    contentHeader: "Visits",
    addButtonLabel: "Add Visit",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetVisits",
    singleItemUrl: "/api/data/GetVisit",
    addUrl: "/api/data/AddVisit",
    editUrl: "/api/data/EditVisit",
    deleteUrl: "/api/data/DeleteVisit",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Visits",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Visits",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    xlsxHeaders: [],
    tableData: [],
  };

  componentDidMount() {
    //this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    if (!this.state.dates[0] || !this.state.dates[1]) {
      toastError("Please select DateFrom and DateTo");
    } else {
      post(
        this.state.dataUrl,
        {
          dateFrom: this.state.dates[0],
          dateTo: this.state.dates[1],
        },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        const rows = apiResponse.data.respData.data;
        this.setState({ tableData: rows });
        this.buildExportHeaders(rows);
      });
    }
  }

  buildExportHeaders(rows) {
    if (!rows || rows.length === 0) return;
    let xlsxHeaders = [];
    for (var property in rows[0]) {
      if (rows[0].hasOwnProperty(property)) {
        xlsxHeaders.push({ title: property, dataIndex: property });
      }
    }
    this.setState({ xlsxHeaders: xlsxHeaders });
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["Name"] = apiResponse.data.respData.data[0].NAME;
      data["Series"] = apiResponse.data.respData.data[0].SERIES;
      data["Price"] = apiResponse.data.respData.data[0].PRICE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 17,
        label: t("col.compound"),
        field: "COMPOUND_NAME",
      },
      {
        id: 1,
        label: t("col.unitName"),
        field: "UNIT_NAME",
      },
      {
        id: 2,
        label: t("col.visitorName"),
        field: "VISITOR_NAME",
      },
      {
        id: 3,
        label: t("col.visitorPhone"),
        field: "VISITOR_PHONE",
      },
      {
        id: 4,
        label: t("col.visitorType"),
        field: "VISITOR_TYPE",
      },
      {
        id: 5,
        label: t("col.description"),
        field: "DESCRIPTION",
      },
      {
        id: 6,
        label: t("col.visitDate"),
        field: "VISIT_DATE",
      },
      {
        id: 7,
        label: t("col.enterDate"),
        field: "ENTRY_DATE",
      },
      {
        id: 8,
        label: t("col.enterBy"),
        field: "ENTER_BY_NAME",
      },
      {
        id: 9,
        label: t("col.exitDate"),
        field: "EXIT_DATE",
      },
      {
        id: 10,
        label: t("col.exitBy"),
        field: "EXIT_BY_NAME",
      },
      {
        id: 11,
        label: t("col.vehicleType"),
        field: "TYPE_NAME",
      },
      {
        id: 12,
        label: t("col.vehicleNumber"),
        field: "VEHICLE_NUMBER",
      },
      {
        id: 13,
        label: t("col.vehicleModel"),
        field: "VEHICLE_MODEL",
      },
      {
        id: 14,
        label: t("col.vehicleColor"),
        field: "VEHICLE_COLOR",
      },
      {
        id: 15,
        label: t("col.notes"),
        field: "NOTES",
      },
      {
        id: 16,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.visits")}</h4>
          </div>
          <div className="col flex-container-left">
            <span style={{ fontSize: 12, fontWeight: 600, color: "var(--text-secondary)", whiteSpace: "nowrap" }}>{t("filter.date")}:</span>
            <Calendar
              selectionMode="range"
              showIcon
              value={this.state.dates}
              onChange={(e) => this.setState({ dates: e.value })}
            />
            <Button
              label={t("btn.search")}
              icon="fa fa-search"
              className="p-button-rounded p-button-secondary"
              disabled={this.props.isLoading}
              onClick={() => this.getData()}
            />
            {this.state.tableData.length > 0 && (
              <ExportSheet
                header={this.state.xlsxHeaders}
                dataSource={this.state.tableData}
                fileName="VisitsExport"
                isRequiredNameDate={false}
                xlsx={XLSX}
              >
                <Button
                  className="p-button-rounded p-button-success"
                  label={t("btn.exportExcel")}
                  icon="fa fa-file-excel-o"
                />
              </ExportSheet>
            )}
          </div>
          {/*<div className="col flex-container-left">*/}
          {/*  {sysJwt.isAuthorized(["CB6A"]) && (*/}
          {/*    <Button*/}
          {/*      label={this.state.addButtonLabel}*/}
          {/*      icon={this.state.addButtonIcon}*/}
          {/*      className="p-button-rounded p-button-secondary"*/}
          {/*      disabled={this.props.isLoading}*/}
          {/*      onClick={() => {*/}
          {/*        this.setState({ inEditMode: false });*/}
          {/*        this.showForm();*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*</div>*/}
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "Name",
                label: "Name",
                disabled: false,
              },
              {
                type: "text",
                id: "Series",
                label: "Series",
                disabled: false,
              },
              {
                type: "text",
                id: "Price",
                label: "Price",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Visits);
